import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export function CountUp({ value, duration = 1.2 }: { value: string; duration?: number }) {
  const num = parseInt(value, 10);
  const isPureNumeric = !isNaN(num) && String(num) === value;
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(isPureNumeric ? "0" : value);

  useEffect(() => {
    if (!inView || !isPureNumeric) return;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) { setDisplay(value); return; }
    const start = performance.now();
    const step = (now: number) => {
      const progress = Math.min((now - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(String(Math.round(num * eased)));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [inView, isPureNumeric, num, value, duration]);

  return <span ref={ref}>{display}</span>;
}
